module.exports = __webpack_public_path__ + "static/media/ic-invoice.8d126eda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-invoice.svg
// module id = 632
// module chunks = 14